import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Button, Paper } from "@mui/material";
import React from "react";
import { loginRequest } from "../authConfig";

const LoginPanel: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };
  const handleLogin = () => {
    instance
      .loginRedirect(loginRequest)
      .then(() => { })
      .catch((e) => {
        console.error(e);
      });
  };
  return (
    <Paper
      sx={{
        backgroundColor: "transparent",
        border: "1px solid #6D4646",
        padding: 1,
        marginLeft: 3,
        marginRight: 3,
        boxSizing: "border-box",
      }}
    >
      {!isAuthenticated && <Button sx={{
        color: "#0E0E0E",
      }} onClick={handleLogin}>Login</Button>}
      {isAuthenticated && <Button sx={{
        color: "#0E0E0E",
      }} onClick={handleLogout}>Logout</Button>}
    </Paper>
  );
};

export default LoginPanel;